// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullAdminRegatta,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Label,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
  InputHtml,
  InputSwitch,
} from '@vroskus/library-components';

// Types
import type {
  $ReducerState,
} from '../../../redux';

type $OptionalProps = {
  onChange?: () => unknown;
};

export type $OwnProps = $OptionalProps & $Translate & {
  item: $FullAdminRegatta;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegattaRegistrationFieldsView = function ({
  item,
  main,
  onChange,
  t,
}: $Props) {
  return (
    <Row>
      <Col md={6}>
        <Row>
          <Col sm={6}>
            <InputDateTime
              label={t('Registration start date')}
              labelOpenCalendar={t('Open calendar')}
              name={'RegistrationStartDate'}
              onChange={onChange}
              timezone={main.timezone}
              value={item.RegistrationStartDate}
            />
          </Col>
          <Col sm={6}>
            <InputDateTime
              label={t('Registration end date')}
              labelOpenCalendar={t('Open calendar')}
              name={'RegistrationEndDate'}
              onChange={onChange}
              timezone={main.timezone}
              value={item.RegistrationEndDate}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'border-thin-top pt-2 mt-auto'}>
            <AvField
              label={(
                <>
                  {t('Custom registration form consent text')}
                  <br />
                  <small className={'text-muted'}>
                    {t('A short text added to the entry form document bottom')}
                  </small>
                </>
              )}
              name={'Consent'}
              onChange={onChange}
              value={item.Consent}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'border-thin-top pt-2'}>
            <Label>
              {t('Regatta registration email appendix')}
              <br />
              <small className={'text-muted'}>
                {t('A free form text added to the registration confirmation email that is sent to regatta entry')}
              </small>
            </Label>
            <InputHtml
              minHeight={180}
              name={'RegistrationContent'}
              onChange={onChange}
              value={item.RegistrationContent}
            />
          </Col>
        </Row>
      </Col>
      <Col md={6}>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center py-1'}>
            {t('Use country instead of registration no.')}
            <InputSwitch
              name={'CountryEnabled'}
              onChange={onChange}
              value={item.CountryEnabled}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Prevent duplicate entry registration no.')}
            <InputSwitch
              name={'PreventDuplicateRegistrationNo'}
              onChange={onChange}
              value={item.PreventDuplicateRegistrationNo}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Allow entries to change group')}
            <InputSwitch
              name={'GroupChangeEnabled'}
              onChange={onChange}
              value={item.GroupChangeEnabled}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Allow entries to input additional sail no.')}
            <InputSwitch
              name={'SailNoEnabled'}
              onChange={onChange}
              value={item.SailNoEnabled}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form entry harbor / city field')}
            <InputSwitch
              name={'RegistrationHarborField'}
              onChange={onChange}
              value={item.RegistrationHarborField}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form entry club field')}
            <InputSwitch
              name={'RegistrationClubField'}
              onChange={onChange}
              value={item.RegistrationClubField}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form crewmember birthdate field')}
            <InputSwitch
              name={'RegistrationBirthdateField'}
              onChange={onChange}
              value={item.RegistrationBirthdateField}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form crewmember email field')}
            <InputSwitch
              name={'RegistrationEmailField'}
              onChange={onChange}
              value={item.RegistrationEmailField}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form crewmember weight field')}
            <InputSwitch
              name={'RegistrationWeightField'}
              onChange={onChange}
              value={item.RegistrationWeightField}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form crewmember tshirt field')}
            <InputSwitch
              name={'RegistrationTshirtField'}
              onChange={onChange}
              value={item.RegistrationTshirtField}
            />
          </Col>
        </Row>
        <Row>
          <Col className={'d-flex justify-content-between align-items-center border-thin-top py-1'}>
            {t('Require to fill registration form crewmember membership id field')}
            <InputSwitch
              name={'RegistrationMembershipField'}
              onChange={onChange}
              value={item.RegistrationMembershipField}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

RegattaRegistrationFieldsView.defaultProps = {
  onChange: undefined,
};

export default RegattaRegistrationFieldsView;
